/**
 * @file app/constants/shows.js
 * Configuration for all show pages.
 * Order matters.
 * Cards show up in an ordered list on their respective show pages eg. arts/shows
 *
 * Current active routes that use this config:
 * show pages:
 * arts/shows
 * news/shows
 * comedy/shows
 * life/shows
 * 2017/shows
 * radio/shows
 *
 */

import _2017 from "./shows/2017";
import arts from "./shows/arts";
import life from "./shows/life";
import pride from "./shows/pride";
import music from "./shows/music";
import news from "./shows/news";
import books from "./shows/books";
import television from "./shows/television";
import documentaries from "./shows/documentaries";

// The order of entries matters! Cards will show up on their respective pages in the order they are defined here.
export const SHOWS = {
    2017: _2017,
    arts: arts,
    pride: pride,
    life: life,
    music: music,
    news: news,
    books: books,
    television: television,
    documentaries: documentaries,
};
